
import { defineComponent } from "vue";
import { usePortalStore } from "@/framework/portal";

export default defineComponent ({
    name: "LandingPage",
    inheritAttrs: false,
    props: {
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: false
        }
    },
    setup() {
        const portal = usePortalStore()
        
        return {
            portal
        };
    }
});